export default __webpack_public_path__ + "static/media/victoria_nails_001.ffac91ac.jpg";